/**
 * Control modal and ajax request page for the RGPD
 * @module $_GP.privacyControl
 * @returns {object}
**/
export default function privacyControl() {

	let FORM_TO_SUBMIT = null;
	let PRIVACY_AGREE  = false;
	let PRIVACY_URL    = null;

	const setForm = (form)=> FORM_TO_SUBMIT = $(form)
	const getForm = ()=> FORM_TO_SUBMIT
	const setPrivacyAgree = (bool)=> PRIVACY_AGREE = bool
	const getPrivacyAgree = ()=> PRIVACY_AGREE

	const requestDataVault = function() {
		let DATA = null;
		return {
			getData : function() { return DATA; },
			setData: function(data) { DATA = data; },
			request: function(url) {
				return $_GP.ajax(url);
			}
		};
	}

	const requestPrivacyPolicy = requestDataVault();

	/**
	 * Control modal and ajax reques for the RGPD
	 * @example
		$_GP.privacyControl.run({ url: 'url/to/endpoint'});
	 * @param {object} opt - options, $_GP.ajax options
	 * @returns {undefined}
	 * @requires $_GP.ajax
	 */
	const run = function(opt) {

		const modal = $('#modal-privacy');

		if (!modal.length) {
			console.error('Bootstrap modal with id="modal-privacy" is required!!!')
			return false
		}

		if (!opt.url) {
			console.error('Option "url" is required')
			return false
		}
		PRIVACY_URL = opt.url
		let MODAL_HAS_RGPD_HTML = false

		modal.find('[data-toggle="modal-agree"]').on('change', function(ev) {
			const agree = $(this).prop('checked');
			if (agree) {
				PRIVACY_AGREE = true;
				modal.find('[data-action="ok"]').removeClass('btn-default')
					.addClass('btn-brand-alt').prop('disabled', false);
				FORM_TO_SUBMIT.find('[data-privacy]').val('1');
			} else {
				PRIVACY_AGREE = false;
				modal.find('[data-action="ok"]').removeClass('btn-brand-alt')
					.addClass('btn-default').prop('disabled', true);
				FORM_TO_SUBMIT.find('[data-privacy]').val('');
			}
		});

		modal.find('[data-action="ok"]').on('click', function name(ev) {
			if (!PRIVACY_AGREE) return;
			FORM_TO_SUBMIT.submit()
		});

		modal.on('show.bs.modal', function() {
			if (MODAL_HAS_RGPD_HTML) return

			const requestData = requestPrivacyPolicy.getData();

			if (!requestData) {
				const $ajax = requestPrivacyPolicy.request(opt.url).done(function(resp) {
					requestPrivacyPolicy.setData(resp);
					modal.find('.modal-body-scroll').html(resp.html);
					modal.find('.modal-title').html(resp.title);
					MODAL_HAS_RGPD_HTML = true
					if (opt.done) opt.done(resp);
				});

				if (opt.$ajax) opt.$ajax(modal,$ajax);
			} else {
				modal.find('.modal-body-scroll').html(requestData.html);
				modal.find('.modal-title').html(requestData.title);
				MODAL_HAS_RGPD_HTML = true
				if (opt.done) opt.done(requestData);
			}
		});

		modal.on('hide.bs.modal', function(ev) {
			FORM_TO_SUBMIT = null;
			PRIVACY_AGREE = false;
			modal.find('[data-toggle="modal-agree"]').prop('checked', false);
			modal.find('[data-action="ok"]').removeClass('btn-brand-alt')
				.addClass('btn-default').prop('disabled', true);
		});
	}

	const steps = (function() {
		let s = 1
		return {
			get: ()=> s,
			inc: ()=> s += 1,
			reset: ()=> s = 1
		}
	}())

	/**
	 * Control ajax requet for the RGPD inside modal with form
	 * @example
		$_GP.privacyControl.insideModal(formBook, {
			url: 'url/to/endpoint',
			done: function(resp) {
				console.log(resp);
			}
		});
	 * @param {string|jQuery} elm - form elements
	 * @param {object} opt - options, $_GP.ajaxSubmitInner options
	 * @returns {undefined}
	 * @requires $_GP.ajax, $_GP.ajaxSubmitInner
	 */
	const insideModal = function(form, opt={}) {
		form = $(form)
		const modal = form.closest('.modal')
		if (!form.length || !modal.length) return

		if (!form.find('[data-privacy]').length) {
			console.error(`data-privacy in #${form.attr('id')} is required (<input type="hidden" name="txtPrivacy" data-privacy>)!!!`)
			return false
		}

		opt.RGPD = opt.RGPD || {}
		let MODAL_HAS_RGPD_HTML = false
		const $_ = $_GP.dataNode(form);

		const resetStep = function(ev) {
			$_.el('btnSubmit').addClass('btn-brand').prop('disabled', false)
			form.find('[data-privacy]').val('')
			form.find('[data-toggle="modal-agree"]').prop('checked', false);
			$_.el('step-1').slideDown()
			$_.el('step-2').slideUp()
			steps.reset()
		}

		form.find('[data-toggle="modal-agree"]').on('change', function(ev) {
			const agree = $(this).prop('checked')
			if (agree) {
				$_.el('btnSubmit').addClass('btn-brand').prop('disabled', false)
				form.find('[data-privacy]').val('1')
			} else {
				$_.el('btnSubmit').removeClass('btn-brand').prop('disabled', true)
				form.find('[data-privacy]').val('')
			}
		});

		modal.on('show.bs.modal', function() {
			if (MODAL_HAS_RGPD_HTML) return

			const requestData = requestPrivacyPolicy.getData();

			if (!requestData) {
				const $ajax = requestPrivacyPolicy.request(PRIVACY_URL).done(function(resp) {
					requestPrivacyPolicy.setData(resp);
					modal.find('.modal-body-scroll').html(resp.html);
					MODAL_HAS_RGPD_HTML = true
					if (opt.RGPD.done) opt.RGPD.done(resp);
				});
				if (opt.RGPD.$ajax) opt.RGPD.$ajax(modal, $ajax);
			} else {
				modal.find('.modal-body-scroll').html(requestData.html);
				MODAL_HAS_RGPD_HTML = true
				if (opt.RGPD.done) opt.RGPD.done(requestData);
			}
		});

		modal.on('hidden.bs.modal', resetStep);

		form.on('submit', function() {
			if (steps.get() === 1) {
				$_.el('step-1').slideUp()
				$_.el('step-2').slideDown()
				$_.el('btnSubmit').removeClass('btn-brand').prop('disabled', true)
				steps.inc()
				return false
			}

			if (steps.get() === 2) {
				$_GP.ajaxSubmitInner(form, opt).done(function(resp) {
					if (!resp.success) {
						resetStep()
						return false
					}
					modal.modal('hide')
				});
			}

			return false
		});
	};

	return { run, setForm, getForm, setPrivacyAgree, getPrivacyAgree /*, insideModal*/}
}
